module.exports = __webpack_public_path__ + "static/media/ben-swolo.5ef60ed3.jpg";